/**
 * 专利管理 学习中心
 */
<template>
    <div class="wel-con-monitor" id="app_index_monitor">
        <!-- 顶部栏展示 -->
        <div class="highTop">
            <div class="highTopCon">
            <div class="highTopConLeft">
                <div style="cursor: pointer;" @click="clickFull()">
                <span v-if="isFullScreen">退出全屏<i style="margin-left: 4px;" class="el-icon-full-screen"></i></span>
                <span v-else>全屏<i style="margin-left: 4px;" class="el-icon-rank"></i></span>
                </div>
                <!-- <div style="cursor: pointer;margin-left: 20px;" @click="jumpConsole()">展示台</div> -->
            </div>
            <div class="highTopConRight">
                <!-- 账户名称 -->
                <!-- 账户设置 -->
                <div>欢迎，{{ currentUser.username }}</div>
                <div style="margin-left: 20px;cursor: pointer;">
                <!-- <span>设置</span><i style="margin-left: 4px;" class="el-icon-s-tools"></i> -->
                <el-popover placement="end" trigger="hover" offset="100">
                    <div style="font-size: 16px;">
                    <div style="margin-top: 14px;" @click="showAccount()">
                        <span>账户设置</span><i style="margin-left: 4px;" class="el-icon-setting"></i>
                    </div>
                    <div style="margin-top: 14px;margin-bottom: 14px;" @click="exit()">
                        <span>退出</span><i style="margin-left: 4px;" class="el-icon-switch-button"></i>
                    </div>
                    </div>
                    <div slot="reference">
                    <span>设置</span><i style="margin-left: 4px;" class="el-icon-s-tools"></i>
                    </div>
                </el-popover>
                </div>
            </div>
            </div>
        </div>
        <div class="ph-container-monitor">
            <div>
                <div style="padding-top: 50px;height: 50%;overflow-y: auto;">
                    <div style="font-size: 24px;padding: 12px;background-color: #008d9b;color: #ffffff;border-radius: 10px;">学习资料</div>
                    <div style="display: flex;padding: 30px;flex-wrap: wrap;height: 300px;overflow-y: auto;border: 1px dashed #008d9b;border-radius: 10px;">
                        <div v-for="item in studyData" title="点击下载" style="width: 15%;text-align: center;margin: 15px 10px;cursor: pointer;" @click="downloadDoc(item)">
                            <img class="folder" src="@/assets/img/PPT.png" />
                            <div style="font-size: 14px;">{{ item.name }}</div>
                        </div>
                    </div>
                </div>
                <div style="padding-top: 50px;height: 50%;overflow-y: auto;">
                    <div style="font-size: 24px;padding: 12px;background-color: #008d9b;color: #ffffff;border-radius: 10px;">审查资料</div>
                    <div style="display: flex;padding: 30px;flex-wrap: wrap;height: 300px;overflow-y: auto;border: 1px dashed #008d9b;border-radius: 10px;">
                        <div v-for="item in examineData" title="点击下载" style="width: 15%;text-align: center;margin: 15px;cursor: pointer;" @click="downloadDoc(item)">
                            <img class="folder" src="@/assets/img/word.png" />
                            <div style="font-size: 14px;">{{ item.name }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <!-- 页面底部 -->
            <div v-if="showBottom" class="bottom_monitor" @mouseenter="showFooter" @mouseleave="hideFooter">
                <div class="bottom24"></div>
                <div class="bottom12">{{ date }} {{ currentDateWeek }}</div>
                <div class="bottom28">
                    <div class="bottom28_item" @click='jumpConsole()'>
                    <div class="bottom28_item_box ">
                        <img class="bottom28_item_img" src="@/assets/img/big_data/zst.png" />
                    </div>
                    <div class="bottom28_item_title">展示台</div>
                    </div>
                    <div class="bottom28_item" @click='jumpMonitor()'>
                    <div class="bottom28_item_box">
                        <img class="bottom28_item_img" src="@/assets/img/big_data/kzt.png" />
                    </div>
                    <div class="bottom28_item_title">控制台</div>
                    </div>
                    <div class="bottom28_item" @click='jumpIntel()'>
                    <div class="bottom28_item_box">
                        <img class="bottom28_item_img" src="@/assets/img/big_data/znpg.png" />
                    </div>
                    <div class="bottom28_item_title">智能评估</div>
                    </div>
                    <div class="bottom28_item">
                    <div class="bottom28_item_box bottom28_item_active">
                        <img class="bottom28_item_img" src="@/assets/img/big_data/xuexi_.png" />
                    </div>
                    <div class="bottom28_item_title">学习中心</div>
                    </div>
                </div>
                <div class="bottom12">数据更新：{{ date }}</div>
                <div class="bottom24"></div>
            </div>
        </div>
         <!-- 账户设置弹窗 -->
         <el-dialog :close-on-click-modal="false" :visible.sync="accountSettingVisible" width="60%" @click='closeDialog("info")' class="dialogInfo dialogSearch" style="overflow: auto;">
            <!-- <div class="highSearchTitle">
            <div style="font-size: 16px;font-weight: 600;color: #606266;height: 30px;line-height: 30px;">账户设置</div>
            <div class="closeSearch" title="关闭" @click="closeAccountDialog()">X</div>
            </div> -->
            <div class="accountDialog" style="height: 70vh;overflow-y: auto;margin-top: 10px;padding-left: 10px;">
            <el-tabs v-model="activeAccountName" type="border-card" @tab-click="handleAccountClick" style="height: 60vh;overflow-y: auto;">
                    <el-tab-pane name="account" label="账户编辑">
                    <el-form label-width="80px" :model="userForm" ref="userForm" :rules="userFormRules">
                        <el-form-item label="账户昵称" prop="name">
                        <el-input v-model="userForm.name" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="面板名称" prop="platform_name">
                        <el-input v-model="userForm.platform_name" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="账户简介" prop="desc">
                        <el-input type="textarea" v-model="userForm.desc" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱">
                        <div v-if="userForm.email">
                            <span>{{ userForm.email }}</span>
                            <!-- <span style="color: #409EFF;cursor: pointer;">更改绑定</span> -->
                        </div>
                        <div v-else>
                            <span style="color: #409EFF;cursor: pointer;">立即绑定</span>
                        </div>
                        </el-form-item>
                        <el-form-item label="手机号">
                        <!-- <el-input v-model="userForm.mobile" disabled></el-input> -->
                        <div v-if="userForm.mobile">
                            <span>{{ userForm.mobile }}</span>
                            <!-- <span style="color: #409EFF;cursor: pointer;">更改绑定</span> -->
                        </div>
                        <div v-else>
                            <span style="color: #409EFF;cursor: pointer;">立即绑定</span>
                        </div>
                        </el-form-item>
                        <el-form-item>
                        <el-button size="small" type="primary" @click="submitUserForm('userForm')">保存</el-button>
                        </el-form-item>
                    </el-form>
                    </el-tab-pane>
                    <el-tab-pane name="password" label="修改密码">
                    <el-form label-width="80px" :model="pwdForm" ref="pwdForm" :rules="pwdFormRules">
                        <el-form-item label="旧密码" prop="oldPwd">
                        <el-input v-model="pwdForm.oldPwd" clearable placeholder="请输入旧密码"></el-input>
                        </el-form-item>
                        <el-form-item label="新密码" prop="newPwdOne">
                        <el-input v-model="pwdForm.newPwdOne" clearable placeholder="请输入新密码"></el-input>
                        </el-form-item>
                        <el-form-item label="新密码" prop="newPwdTwo">
                        <el-input v-model="pwdForm.newPwdTwo" clearable placeholder="请再次输入新密码"></el-input>
                        </el-form-item>
                        <el-form-item>
                        <el-button size="small" type="primary" @click="submitPwdForm('pwdForm')">保存</el-button>
                        </el-form-item>
                    </el-form>
                    </el-tab-pane>
            </el-tabs>
            </div>
            <div class="searchBtnDialogTop">
            <div class="searchBtnDialog" style="background-color: #999999;margin-top: 10px;" @click="closeAccountDialog()">关闭</div>
            <!-- <div class="searchBtnDialog" style="margin-top: 10px;">保存</div> -->
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { 
  getAdminInfo,
  editAdminInfo,
  resetAdminPwd,
  getAdminLearnList
}from '../../api/patentMG'
import autofit from 'autofit.js'
import md5 from 'js-md5'
import Pagination from '../../components/Pagination'
import { checkLogin, fullscreenToggel } from '../../utils/util'
import '../../assets/js/directive'
export default {
    data() {
        return {
            // 学习文档数据
            studyData: [],
            // 表格下载数据
            examineData: [],
            // 当前登录账户信息
            currentUser: [],
            // 底部按钮是否显示
            showBottom: true,
            // 是否全屏
            isFullScreen: false,

            // 初始化窗口高宽
            screenWidth: document.body.clientWidth,
            screenHeight: document.body.clientHeight,
            // 页面底部数据
            date: '',
            currentDateWeek: '',
            // 账户设置弹窗
            accountSettingVisible: false,
            // 账户设置默认选择标签
            activeAccountName: 'account',
            // 账户信息
            userForm: {
                name: '',
                platform_name: '',
                email: '',
                mobile: '',
                head: '',
                desc: ''
            },

            // 修改密码
            pwdForm: {
                oldPwd: '',
                newPwdOne: '',
                newPwdTwo: ''
            },

            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },

            userFormRules: {
                name: [
                { required: true, message: '账户昵称不能为空', trigger: 'blur' }
                ],
                platform_name: [
                { required: true, message: '面板名称不能为空', trigger: 'blur' }
                ]
            },
            pwdFormRules: {
                oldPwd: [
                { required: true, message: '旧密码不能为空', trigger: 'blur' }
                ],
                newPwdOne: [
                { required: true, message: '新密码不能为空', trigger: 'blur' }
                ],
                newPwdTwo: [
                { required: true, message: '新密码不能为空', trigger: 'blur' }
                ],
            },

        }
    },
    // 注册组件
    components: {
        Pagination
    },
    // 数据发生改变
    watch: {},
    // 创建完毕
    created() {
        console.log('------页面创建------')
        let user = JSON.parse(localStorage.getItem('userdata'))
        this.currentUser = user
        console.log(user)
        this.getStudyData()
        this.getExamineData()
    },
     // 挂载结束状态(里面是操作)
    mounted() {
        var _this = this
        window.onresize = () => {
        return (() => {
            _this.screenHeight = document.body.clientHeight
            _this.screenWidth = document.body.clientWidth
        })()
        }
        autofit.init({
        designHeight: 1080,
        designWidth: 1920,
        renderDom: "#app_index_monitor",
        resize: true
        })
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1; // 月份从0开始，需要加1
        const day = currentDate.getDate();
        this.date = year + '.' + month.toString().padStart(2, '0') + '.' + day.toString().padStart(2, '0')
        this.currentDateWeek = new Intl.DateTimeFormat('zh-CN', { weekday: 'long' }).format(new Date());
    },
   
    // 里面的方法只有被调用才会执行
    methods: {
        // 点击全屏按钮
        clickFull() {
            // 是否全屏
            this.isFullScreen = !this.isFullScreen;
            fullscreenToggel();
        },
        // 鼠标移入时显示底部
        showFooter() {
            this.showFooterByDefault = true;
        },
        // 鼠标移出时隐藏底部
        hideFooter() {
            this.showFooterByDefault = false;
        },
           // 跳转展示台
        jumpConsole() {
            this.$router.push({ path: '/console/consoleAgency' })
        },
        // 跳转到智能评估
        jumpIntel(){
            this.$router.push({ path: '/patent/intelEval' })
        },
        // 跳转到学习中心
        jumpMonitor(){
            this.$router.push({ path: '/patent/monitor' })
        },
        // 退出登录
        exit() {
        this.$confirm('退出登录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        })
        .then(() => {
            setTimeout(() => {
                this.$store.commit('logout', 'false')
                window.localStorage.removeItem('userInfo');
                window.localStorage.removeItem('userdata');
                window.localStorage.removeItem('logintoken');
                this.$router.push({ path: '/login' })
                this.$message({
                type: 'success',
                message: '已退出登录!'
                })
            }, 1000)
        })
        },
        // 显示账户设置弹窗
        showAccount() {
          // 查询账户信息
          const param = {}
            getAdminInfo(param)
            .then(res => {
              res = checkLogin(res)
              if (res.code == 200) {
                this.userForm = res.data
                this.accountSettingVisible = true
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('系统错误！')
            })
          
        },
        // 关闭账户设置弹窗
        closeAccountDialog() {
          this.accountSettingVisible = false
        },

        // 保存账户信息
        submitUserForm: function(userForm) {
          this.$refs[userForm].validate(valid => {
            if(valid){
              let param = {
                name: this.userForm.name,
                platform_name: this.userForm.platform_name,
                desc: this.userForm.desc
              }
              editAdminInfo(param)
              .then(res=>{
                  if(res.code == 200){
                    this.$message({
                      type: 'success',
                      message: res.msg
                    })
                    this.accountSettingVisible = false
                  }else{
                    this.$message({
                      type: 'error',
                      message: res.msg
                    })
                  }
              })
            }else{
              return false
            }
          })
        },
        submitPwdForm: function(pwdForm){
          this.$refs[pwdForm].validate(valid => {
            if(valid){
              if(this.pwdForm.newPwdOne != this.pwdForm.newPwdTwo){
                  this.$message({
                    type: 'error',
                    message: '新密码两次不一致!'
                  })
                  return false
              }
              let param = {
                oldPwd: md5(this.pwdForm.oldPwd),
                newPwdOne: md5(this.pwdForm.newPwdOne)
              }
              resetAdminPwd(param)
                .then(res => {
                res = checkLogin(res)
                if (res.code == 200) {
                  this.accountSettingVisible = false
                  this.$message({
                    type: 'success',
                    message: res.msg
                  })
                } else {
                    this.$message({
                    type: 'error',
                    message: res.msg
                    })
                }
                })
            }else{
              return false
            }
          })
        },
        // 账户设置选项卡点击事件
        handleAccountClick(tab,event) {
          let tabName = tab.name
          this.activeAccountName = tabName
          console.log(this.activeAccountName)
        },
        // 查询学习资料
        getStudyData(){
          let param = {
            category: 'study'
          }
          getAdminLearnList(param)
          .then(res=>{
            if(res.code == 200){
              this.studyData = res.data
            }
          })
        },
        // 查询审查资料
        getExamineData(){
          let param = {
            category: 'examine'
          }
          getAdminLearnList(param)
          .then(res=>{
            if(res.code == 200){
              this.examineData = res.data
            }
          })
        },
        // 下载文档
        downloadDoc(data){
            console.log(data)
            this.$confirm('确定要下载吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(()=>{
            window.location.href = data.url
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
        },
        // 关闭编辑、增加弹出框
        closeDialog(dialog) {
          if (dialog == 'edit') {
            this.editFormVisible = false
          } else if (dialog == 'info') {
            this.infoFormVisible = false
          }else if(dialog == 'payable'){
            this.payableFormVisible = false
          }else if(dialog == 'addInvoice'){
            this.showAddInvoiceVisible = false
          }
        },
    }
}
</script>
<style scoped>
#app {
  position:fixed !important;
}
.wel-con-monitor {
  margin-top: 60px;
  width: 100%;
  height: 100%;
  min-width: 1200px;
  min-height: 800px;
  box-sizing: border-box;
  /* position: relative; */
}
.ph-container-monitor {
  margin: 0 90px !important;
  /* max-width: 1740px;
  min-width: 1024px; */
  min-width: 1200px;
  min-height: 800px;
  height: 80%;
 }
.user-search {
  margin-top: 10px;
}
.userRole {
  width: 100%;
}
.left-filter-top {
  font-size: 14px;
  margin: 10px 0;
  width: 180px;
  border-bottom: 1px solid #EBEEF5;
}
.search-top {
  border: 1px solid #EBEEF5;
  margin: 10px 0;
  border-radius: 5px;
  padding: 0 15px;
}
.search-top2 {
  margin: 10px 0;
  height: 40px;
  display: flex;
}
.search-input {
  height: 40px;
  border: 1px solid #aee8ff;
  border-radius: 4px;
  width:  90%;
}
.search-btn {
  widows: 10%;
  background-color: #008d9b;
  height: 40px;
  line-height: 40px;
  color: #ffffff;
  text-align: center;
  font-size: 14px;
}
.el-form-item {
    margin-bottom: 10px;
}
.el-input{
  color: #606266;
  width: auto;

}
.export_scope input{
  width: 60px;
}
.aboutDialog >>> .el-dialog__body{
  padding: 0px !important;
  padding:15px !important;
}
.aboutDialog >>> .el-dialog__header {
  padding: 10px 20px;
  height: 25px;
  line-height: 25px;
  text-align: left;
  background: #F8F8F8;
  border-bottom: solid 1px #eee;
}
.aboutDialog >>> .el-dialog__title {
  color: #333;
  font-size: 14px;
}
.aboutDialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: #333;
}
.search-sidebar {
  width: 10%;
  border: solid 1px #EBEEF5;
  /* margin-left: 15px; */
  min-width: 200px;
  font-size: 14px;
}
.search-sidebar .item {
  display: block;
  font-weight: 400;
  margin: 15px 10px;
}
.filter_btn {
  color: #21BA45;
  border: solid 1px #21BA45;
  padding: 6px 6px;
}
.perk_btn {
  color: #DB2828;
  border: solid 1px #DB2828;
  padding: 6px 6px;
}
.patentInfoBase .el-form-item{
  margin-bottom: 0px;
}
.search-sidebar .el-collapse {
  border-bottom: 0px solid #EBEEF5;;
}
.leftCheckbox >>>.el-checkbox__input {
  position: absolute;
  top: 2px;
  left: 0;
}
.leftCheckbox >>>.el-checkbox__label {
  min-width: 130px;
  max-width: 160px;
  display: inline-block;
  white-space: pre-line;
  word-wrap: break-word;
  overflow: hidden;
  line-height: 19px;
  font-size: 14px;
  padding-left: 20px;
}
.content-item {
  margin-bottom: 2px;
}
.content-label {
  color: #808080;
}
ul {
  list-style: none;
  margin-left: -20px;
  font-size: 12px;
  line-height: 2;
}
.patent-info-column {
  width: 100px;
  display: inline-block;
}
.patent-info-number {
  width: 200px;
  display: inline-block;
}
/* .searchTable > tr {
  height: 40px;
} */
.searchTable .label {
  width: 80px;
  min-width: 80px;
}
.searchTable .select {
  width: 350px;
  min-width: 350px;
}
.searchTable .el-form-item {
  margin-bottom: 5px;
}
.searchTable >>>.el-form-item__label {
  font-weight: 600;
}
.searchTable >>>.el-form-item__content {
  line-height: 20px;
}
.el-dialog-div {
  height: 60vh;
  overflow-x: hidden;
}
.legalContent {
  /* border: solid 1px #b3b1b1; */
  padding: 6px 8px;
  border-radius: 4px;
  background-color: #F4F4F4;
}
.applicantGroup {
  max-height: 450px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.applicantGroup::-webkit-scrollbar {
    width: 4px;
  }
.applicantGroup::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  opacity: 0.2;
  /* background: fade(#409EFF, 60%); */
}
.applicantGroup::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  /* background: fade(@primary-color, 30%); */
}
.searchTop {
  height: 40px;
  display: flex;
  margin-top: 20px;
}
.searchInput {
  height: 40px;
  width: 90%;
  border: 1px solid #A4E4FF;
  border-radius: 4px;
  /* cursor: pointer; */
  line-height: 40px;
  color: #606266;
  padding: 0px 14px;
}

.searchBtn {
  height: 40px;
  width: 10%;
  margin-left: 20px;
  color: #FFFFFF;
  text-align: center;
  line-height: 40px;
  background-color: #008D9B;
  border-radius: 4px;
  float: right;
  cursor: pointer;
}
.searchBtnDialog {
  height: 40px;
  width: 120px;
  margin-left: 20px;
  color: #FFFFFF;
  text-align: center;
  line-height: 40px;
  background-color: #008D9B;
  border-radius: 4px;
  cursor: pointer;
  /* margin-top: 10px; */
}
.searchBtnDialogTop {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  border-top: 1px solid #999999;
}
.bottom_monitor {
  width: 100%;
  height: 10%;
  text-align: center;
  display: flex;
  /* display: none; */
  justify-content: space-between;
  background-image: url("../../assets/img/monitor_bottom.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  bottom: 0;
}
.bottom_monitor.bottom_show {
  display: flex;
}
.bottom24 {
  width: 24%;
}

.bottom12 {
  width: 12%;
  height: 61px;
  color: #f9fbff;
  position: relative;
  line-height: 61px;
  top: 50px;
  /* top: 35px; */
}

.bottom28 {
  /* width: 25.5%; */
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 17px;
  color: #FFFFFF;
  padding-left: 140px;
  padding-right: 140px;
  box-sizing: border-box;
  position: relative;
}

.bottom28_item_box {
  box-shadow: 0px 0px 13px 3px rgba(2, 26, 67, 0.09);
  border-radius: 50%;
  width: 45px;
  height: 45px;
  position: absolute;
  top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bottom28_item_active {
  background: #FFFFFF;
}

.bottom28_item_title {
  position: absolute;
  /* bottom: 16px */
  bottom: 8px
}

.bottom28_item {
  flex: 1;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 14px;
  box-sizing: border-box;
  cursor: pointer;
}

.bottom28_item_img {
  width: 25px;
  height: 25px;
  /* width: 10%;
  height: 20%; */
}
.bottom-btn {
  padding: 4px 10px;
  border: solid 0.5px #EBEEF5;
  color: #999999;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}
.bg008D9B {
  color: #ffffff;
  background-color: #008D9B;
  border: none;
}
.bgFF7070 {
  color: #ffffff;
  background-color: #FF7070;
  border: none;
}
.marginl {
  margin-left: 10px;
}
.leftColl>>>.el-collapse-item__header {
  height: 30px !important;
}
.contentBody {
  width: 70%;
}
.contentBody>>>.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #008D9B;
}
.dialogInfo>>>.el-tabs--border-card {
 border: none !important;
 box-shadow: none !important;
}
.dialogInfo>>>.el-tabs--border-card>.el-tabs__header {
  background-color: #ffffff !important;
  border-bottom: none !important;
}
.dialogInfo>>>.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
  color: #ffffff !important;
  background-color: #008D9B !important;
  border-radius: 4px !important;
}
.dialogInfo>>>.el-tabs--border-card>.el-tabs__header .el-tabs__item {
  border-radius: 4px;
  margin-left: 10px;
  height: 30px !important;
  line-height: 30px !important;
  background-color: #EBEEF5 !important;
}
.dialogInfo>>>.el-tabs--border-card>.el-tabs__header .el-tabs__item:hover {
  color: #008D9B;
}
.topFilter {
  background-color: #008D9B;
  color: #ffffff;
  border: none;
}
.width90 {
  width: 90%;
}
.width100 {
  width: 100%;
}
.listContent {
  border: solid #EBEEF5 1px;
  padding: 10px 10px;
  font-size: 14px;
  border-radius: 5px;
  height: 670px;
  overflow-y: auto;
}
.infoDrag {
  margin-left: 10px;
  margin-bottom: 14px;
  font-size: 16px;
}
.wel-con-monitor>>>.el-icon-close:before {
  font-size: 20px !important;
}
/* .el-dialog-div>>>.el-table th {
  background-color: #666666 !important;
  color: #ffffff !important;
} */
.nearPayIcon {
  width: 60px;
  height: 60px;
  box-sizing: border-box;
  background-image: url("../../assets/img/nearPay.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.payListIcon {
  width: 60px;
  height: 60px;
  box-sizing: border-box;
  background-image: url("../../assets/img/payList.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.highTop {
  position: absolute;
  top: 0px;
  height: 40px;
  background-color: #999999;
  width: 100%;
}
.highTopCon {
  margin: 0 90px;
  display: flex;
}
.highTopConLeft {
  height: 40px;
  width: 50%;
  line-height: 40px;
  color: #ffffff;
  display: flex;
}
.highTopConRight {
  height: 40px;
  width: 50%;
  line-height: 40px;
  color: #ffffff;
  display: flex;
  justify-content: flex-end;
}
.dialogSearch>>>.el-dialog__header{
  display: none !important;
}
.closeSearch {
  font-size: 20px;
  height: 30px;
  line-height: 30px;
  margin-left: auto;
  margin-right: 0px;
  cursor: pointer;
}
.highSearchTitle {
  display: flex;
  height: 30px;
  line-height: 30px;
  background-color: rgba(0, 141, 155, 0.2);
  border-radius: 4px;
  padding: 4px 10px;
}
.value>>>.el-input__inner {
  height: 30px;
}
.value>>>.el-input__icon {
  line-height: 30px;
}
.labelName {
  border: 1px solid #DCDFE6;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 12px;
  width: 140px;
  border-radius: 4px;
}
.searchInput>>>.el-input {
  /* width: 130px !important; */
}
.searchInput>>>.el-input__inner {
  border: none !important;
}
.elInput>>>.el-input__inner {
  /* width: 700px !important; */
  width: 100vh !important;
  /* width: 100% !important; */
}
.accountDialog>>>.el-form-item__label {
  text-align: left !important;
}
.accountDialog>>>.el-form-item {
  margin-bottom: 22px !important;
}
.folder {
  width: 50px;
  height: 50px;
  margin-left: auto;
  margin-right: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/patent/learnCenter.vue